/**
 * The booking status between "talent confirmed" and "credit note created".
 *
 * Client process (Anke, 2026-08):
 *   1. Talent is confirmed  → booking confirmation email only, NO Gutschrift.       ← this status
 *   2. After the job is done → the Gutschrift PDF is created (several tasks can be
 *      combined into one document) and mailed to the talent. Creating it flips the
 *      booking to 'Booked' (light blue), which the backend does in credit_note.service.js.
 *   3. Accounting downloads the PDFs of the past week as a ZIP.
 *
 * The PDF is deliberately created late so the tasks can still be adjusted. Once it has
 * been sent, the document must not change any more — corrections go through a Storno
 * plus a new document with a new number (Lars, 2026-08).
 *
 * Bookings billed through Lano never reach this status: those go straight to 'Booked'
 * when the Lano task is created, so the credit note queue only holds what it should.
 */
export const STATUS_CREDIT_NOTE_PENDING = 'confirmedCreditNote';

/** Label used in status dropdowns and legends. */
export const STATUS_CREDIT_NOTE_PENDING_LABEL = 'confirmed / credit note pending';

/**
 * Calendar + list colour. Light blue (#ADD8E6) stays reserved for 'Booked', i.e. "the
 * Gutschrift exists", because that is the colour the client asked for on that step.
 */
export const STATUS_CREDIT_NOTE_PENDING_COLOR = '#0f8f8f';

/** Same colour as an [r, g, b] triple, for the badge maps that mix their own contrast. */
export const STATUS_CREDIT_NOTE_PENDING_RGB = [15, 143, 143];
